import mixpanel from 'mixpanel-browser';
import {LooseObject} from '../types';

export class AnalyticsService {
  mixpanel: {};
  sharedInstance: any;

  // @ts-ignore
  static sharedInstance = AnalyticsService.sharedInstance || new AnalyticsService();

  constructor() {
    this.mixpanel = {};
    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN as '', {debug: process.env.REACT_APP_ENV === 'development', ignore_dnt: true});
  }

  static track(event: string, data?: LooseObject): void {
    process.env.REACT_APP_ENV !== 'development' && mixpanel.track(event, data, {send_immediately: true});
  }
}
